
import { ConditionCategoryState } from './types';

export const state = (): ConditionCategoryState => initialState();

export const initialState = (): ConditionCategoryState => ({
  conditionCategorys: {
    //TODO remove when was made backend
    items: [],
    isLoading: false,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [''],
      andClauseFieldsIds: [],
    },
  },
});
